import Headers from 'fetch-headers';

if (!window.Headers) {
  window.Headers = Headers;
}
